export function useRootBreadcrumb(route) {
    const { t } = useI18n()

    let href = `/${route.path.split("/")[1]}`

    let label = "";

    if (route.name.includes("restaurants")) {
        label = t('shared.nav.restaurants');
        href = "restauranger"
    }

    if (route.name === "all" && route.path.includes("/artiklar")) {
        label = t('shared.nav.articles');
    }

    if (route.name === "all" && route.path.includes("/guider")) {
        label = t('shared.nav.guides');
    }

    if (route.name.includes('offers')) {
        label = t('shared.nav.offers');
    }

    if (route.name.includes('events')) {
        label = t('shared.nav.events');
    }

    if (route.name.includes('giftcards')) {
        label = t('shared.nav.events');
    }

    if (route.name.includes('search')) {
        label = t('shared.nav.search');
    }

    return {
        label,
        href,
    }
}